import ErrorPageTemplate from "../../components/ErrorPageTemplate";


export default function NotAuthorized () {
    return (
        <ErrorPageTemplate 
            errorImage="img/error_403.png"
            errorDescription={"Desculpe, você não tem acesso a página que tentou acessar,\npara mais dúvidas contatar o suporte."}
            buttonText="Voltar para página anterior"
            buttonLink="/"
        />
    )
}